import { render } from "./yesNo.vue?vue&type=template&id=34c2979e&scoped=true&ts=true"
import script from "./yesNo.vue?vue&type=script&lang=ts"
export * from "./yesNo.vue?vue&type=script&lang=ts"

import "./yesNo.vue?vue&type=style&index=0&id=34c2979e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c2979e"]])

export default __exports__